'use client'

import { useAuthStore } from '../stores/auth.store'
import type { UserRole } from '@okra/shared'

const roleHierarchy = {
  SALES_REP: 1,
  AGENCY_MGR: 2,
  DIRECTOR: 3,
  ADMIN: 4,
} as const

type RoleName = keyof typeof roleHierarchy | 'STOCK_MGR' | 'ACCOUNTANT'

export function useCurrentUser() {
  return useAuthStore((s) => s.user)
}

export function useIsLoading() {
  return useAuthStore((s) => s.isLoading)
}

/**
 * Returns true if the current user has at least the minimum required role.
 */
export function useIsAllowed(minRole: RoleName | UserRole): boolean {
  const user = useAuthStore((s) => s.user)
  if (!user) return false
  return (roleHierarchy[user.role as keyof typeof roleHierarchy] ?? 0) >= (roleHierarchy[minRole as keyof typeof roleHierarchy] ?? 0)
}

/**
 * Returns true if the current user has exactly one of the specified roles.
 */
export function useHasRole(...roles: (RoleName | UserRole)[]): boolean {
  const user = useAuthStore((s) => s.user)
  if (!user) return false
  return (roles as string[]).includes(user.role)
}
